import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UrlValidator } from '../validators/url-validator';
import { StorageHelper } from '../storage/storage-helper';
import { LogHelper } from '../logging/log-helper';

@Injectable({
  providedIn: 'root',
})
export class ApiSelectorService {
  private _isEnabled: boolean
  get isEnabled(): boolean { return this._isEnabled; }
  get isActive(): boolean { return !!this.overrides.size; }
  
  private readonly overrides: Map<string, string> = new Map();

  constructor() {
    this._isEnabled = StorageHelper.isEnabledChangeEnvironments();
    const map = StorageHelper.getEnvironmentOverrides();
    if (map) {
      let isValid = true;
      // make sure values are valid URLs before applying
      map?.forEach((v, k) => isValid = isValid && UrlValidator.isValid(k) && UrlValidator.isValid(v));
      if (isValid) {
        this.overrides = map;
      }
    }
  }

  reset() {
    this.overrides.clear();
    this.persistOverrides();
  }
  
  addOverride(original: string, override: string) {
    if (!original) return;
    if (!override) return this.removeOverride(original);
    if (original === override) return this.removeOverride(original);
    this.overrides.set(original, override);
    this.persistOverrides();
  }

  removeOverride(original: string) {
    if (!original) return;
    this.overrides.delete(original);
    this.persistOverrides();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateRequest(request: HttpRequest<unknown>): HttpRequest<unknown> {
    if (!request?.url) return request;
    this.overrides.forEach((v, k) => {
      if (request.url.includes(k)) {
        const updated = request.url.replace(k, v);
        LogHelper.debug('ApiSelector', 'replacing url: ', request.url, updated);
        request = request.clone({ url: updated });
      }
    });

    return request;
  }

  getValue(original: string): string {
    return this.overrides.get(original) || original;
  }
  
  containsKey(original: string): boolean {
    return this.overrides.has(original);
  }

  containsValueForUrl(url: string): boolean {
    return Array.from(this.overrides.values()).findIndex((value) => url.startsWith(value)) !== -1;
  }

  enableChangeEnvironments() {
    StorageHelper.saveIsEnabledChangeEnvironments(true);
    this._isEnabled = true;
  }

  disableChangeEnvironments() {
    StorageHelper.saveIsEnabledChangeEnvironments(false);
    this._isEnabled = false;
  }

  private persistOverrides() {
    StorageHelper.saveEnvironmentOverrides(this.overrides);
  }
}
